import React from 'react';

import { Container, Paragraph } from './styles';
import Header from '../../components/HeaderMenuContent';
import Aprovado from '../../assets/aprovado.png';
import Button from '../../components/Button';
import { useNavigate } from 'react-router-dom'

export default function RedemptionReceivedAndApproved() {
    const navigate = useNavigate()
    function RoutesHome () {
        navigate('/loja' )
      }
    
    return (
        <>
            <Header />
            <Container>
                <Paragraph>
                    <img src={Aprovado} alt="Order" />
                    <p className="title">Resgate recebido e aprovado com sucesso!</p>
                    <p className="order">Pedido n° 505897 </p>
                    <p className="color">Agora é com a gente: logo logo, te enviamos um e-mail de confirmação.</p>
                </Paragraph>
                <Button onClick={RoutesHome}>VOLTAR PARA HOME</Button>
            </Container>
        </>
    )

}